import { useMemo, useContext } from "react";
import { useQuery } from "@apollo/react-hooks";

import {
    GET_PHOTO_SHOOT_FOR_ADDING_UPLOADS,
    FETCH_UPLOAD_BATCHES
} from "../queries";

import { usePhotoUploadsInDropzone, useFailedPhotoUploads } from "./index";
import AllPhotoUploadsContext from "../context/AllPhotoUploadsContext";

const useExistingUploads = () => {
    const AllPhotoUploadsContextValues = useContext(AllPhotoUploadsContext);
    const { withdrawnUploadsData } = AllPhotoUploadsContextValues;

    const withdrawnUploads =
        withdrawnUploadsData &&
        withdrawnUploadsData.withdrawnPhotoUploads &&
        withdrawnUploadsData.withdrawnPhotoUploads.items;

    const {
        uploads: uploadsInDropzone,
        dataLoaded: uploadsInDropzoneDataLoaded
    } = usePhotoUploadsInDropzone();
    const {
        fileCheckFailedUploads: failedUploads,
        fileCheckFailedUploadsDataLoaded
    } = useFailedPhotoUploads();

    const getExistingUploads = () => [...uploadsInDropzone, ...failedUploads];

    const existingUploads = useMemo(getExistingUploads, [
        uploadsInDropzone,
        failedUploads
    ]);

    const {
        data: shootData,
        called: shootQueryCalled,
        loading: shootQueryLoading
    } = useQuery(GET_PHOTO_SHOOT_FOR_ADDING_UPLOADS, {
        fetchPolicy: "cache-and-network"
    });

    const {
        data: batchData,
        called: batchQueryCalled,
        loading: batchQueryLoading
    } = useQuery(FETCH_UPLOAD_BATCHES, {
        fetchPolicy: "cache-and-network"
    });

    const getExistingUploadBatch = () => {
        if (!batchData) return;

        const batch = batchData.batches.items.find(
            batch => batch.moderationStatus === "batch_unsubmitted"
        );

        return batch;
    };

    const hasExistingUploadBatch = !!getExistingUploadBatch();

    const getExistingPhotoShoot = () => {
        if (!shootData || !shootData.shoot) return;
        return shootData.shoot;
    };

    const existingPhotoShoot = getExistingPhotoShoot();

    return {
        existingPhotoShootId: existingPhotoShoot && existingPhotoShoot.id,
        hasExistingUploadBatch,
        hasExistingPhotoShoot: !!existingPhotoShoot,
        batchDataLoaded: batchQueryCalled && !batchQueryLoading,
        shootDataLoaded: shootQueryCalled && !shootQueryLoading,
        existingUploads,
        existingUploadsDataLoaded:
            fileCheckFailedUploadsDataLoaded && uploadsInDropzoneDataLoaded,
        withdrawnUploadsData,
        withdrawnUploads
    };
};

export default useExistingUploads;
